import { useReduxState } from 'hooks';
import { Button, MoreOptions } from 'components/common';

interface Props {
  onDeleteAllClick: () => Promise<void>;
  onMarkAllClick: () => Promise<void>;
  onShowUnseenClick: () => Promise<void>;
  showUnseen: boolean;
}

const NotificationsCenterControls = ({
  onDeleteAllClick,
  onMarkAllClick,
  onShowUnseenClick,
  showUnseen
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="notification-controls" data-keep-open={true}>
      <div className="title">{messages.commonNotifications}</div>

      <MoreOptions renderAsFixed={true}>
        <Button
          onClick={onShowUnseenClick}
          {...(showUnseen
            ? {
                icon: 'eye',
                text: messages.notificationsShowAll
              }
            : {
                icon: 'eye-slash',
                text: messages.notificationsShowOnlyUnread
              })}
        />

        <Button
          icon="check"
          onClick={onMarkAllClick}
          text={messages.notificationsMarkAllAsRead}
        />

        <Button
          icon="trash-alt"
          onClick={onDeleteAllClick}
          text={messages.notificationsDeleteAllRead}
        />
      </MoreOptions>

      <style jsx>{`
        .notification-controls {
          align-items: center;
          border-bottom: 1px solid ${theme.lightGreyDark};
          color: ${theme.textColorLight};
          display: flex;
          font-size: 1.6rem;
          font-weight: 700;
          justify-content: space-between;
          padding: 10px 10px 10px 15px;
        }
      `}</style>
    </div>
  );
};

export default NotificationsCenterControls;
